import ChequeIcon from "./ChequeIcon.mjs";

/** @type {GlyphIcon} */
export default ChequeIcon;